module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmt",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#rack"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("I’d like to thank the coaches and athletes I had the pleasure of meeting in the months I was getting acquainted with the sport at the following boxes: CrossFit Cedar Rapids, CrossFit Invictus, CrossFit NYC, CrossFit Southie, CrossFit Bloomington, CrossFit East Village, and CrossFit Santa Cruz Central. I’d particularly like to thank Brian MacKenzie, Kelly and Juliet Starrett, Carl Paoli, Todd Widman, Lindsey Smith, Annie Sakamoto, Dave Castro, Nicole Carroll, Gretchen Weber, and Greg Amundson—all of whom went above and beyond in helping me with this project.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I especially want to thank the staff at VeloPress for their guidance and enthusiasm in putting together this book. While I’ve had the pleasure of working with them over the years at Competitor Group, this was the first direct experience I’d had in seeing their passion and professionalism up close.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 75
// module chunks = 0